/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2023.
 */

export const LANGUAGE_STATE_KEY = 'language';
export const LANGUAGE_SESSION_KEY = 'languageUpdateSession';
export const SLASH = '/';
